import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const LanguageSelectorWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`;
